import { ChangeEvent, ReactElement } from "react";
import { FormControlLabel, Switch, TextField } from "@mui/material";
import { IFamilyBase } from "../../types";
import { useSelector } from "react-redux";
import { IState } from "../../../../types";

interface IProps {
  family: IFamilyBase;
  setFamily: (family: IFamilyBase) => void;
}

const FamilyConfig = ({ family, setFamily }: IProps): ReactElement => {
  const selectedNode = useSelector((state: IState) => state.selectedNode);

  const onChange = (field: keyof IFamilyBase, value: string) => {
    setFamily({ ...family, [field]: value });
  };

  const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
    setFamily({
      ...family,
      nodeID: event.target.checked ? selectedNode.nodeID : null,
      nodeType: event.target.checked ? selectedNode.type : null, });
  };

  return (
    <div className="display-flex-column p-2 gap-2">
      <FormControlLabel
        control={<Switch checked={family.nodeID !== null} onChange={handleChange} name="isPrivate" />}
        label={`Private - "${selectedNode.name}"`}
      />
      <TextField
        variant="standard"
        placeholder={"Name"}
        label={"Name"}
        value={family.name}
        onChange={(e) => onChange("name", e.target.value)}/>

      <TextField
        variant="standard"
        placeholder={"Description"}
        label={"Description"}
        value={family.description}
        onChange={(e) => onChange("description", e.target.value)}/>

    </div>
  );
};

export default FamilyConfig;
